'use client';

import * as React from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

import { exitSpace } from '@/services/user';
import { authChannelPostMessage } from '@/lib/channel';
import { useI18n } from '@/hooks/use-i18n';

interface ConfirmLogoutSpaceModalProps {
  open: boolean;
  onClose: () => void;
  userInfo: USER.Profile;
}

const ConfirmLogoutSpaceModal = ({
  open,
  onClose,
  userInfo,
}: ConfirmLogoutSpaceModalProps) => {
  const { t } = useI18n(['components', 'common']);
  const [loading, setLoading] = React.useState(false);

  const handleLogoutSpace = async () => {
    setLoading(true);
    try {
      await exitSpace();
      onClose();
      window.DM_SPACE_ID = '';
      // 刷新页面以更新用户信息
      window.location.reload();

      // 派发空间切换
      authChannelPostMessage({
        type: 'spaceChange',
        payload: {
          spaceId: '',
        },
      });
    } catch (error) {
      console.error('退出团队失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="w-[400px] p-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="h-[56px] flex items-center justify-center">
          <DialogTitle className="text-center text-lg font-semibold">
            {t('components:sidebar.exitTeam.title')}
          </DialogTitle>
        </DialogHeader>
        <>
          <div className="text-[14px] text-[rgba(0,0,0,0.75)] px-[24px] h-12">
            {t('components:sidebar.exitTeam.confirmMessage', {
              teamName: userInfo?.active_space?.space_name,
            })}
          </div>
          <div className="flex justify-end items-center space-x-4 px-[24px] mb-6">
            <Button
              variant="secondary"
              onClick={onClose}
              className="rounded-md px-7 py-2.5 bg-[#F1F1FC] hover:bg-[#f1f1fc] text-[#7171EE] text-[13px] h-auto"
            >
              {t('common:cancel')}
            </Button>
            <Button
              disabled={loading}
              onClick={handleLogoutSpace}
              className="bg-[#7171ee] hover:bg-[#5959c7] text-white rounded-md px-7 py-2.5 text-[13px] h-auto"
            >
              {t('common:confirm')}
            </Button>
          </div>
        </>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmLogoutSpaceModal;
